import * as React from "react";
import { Link } from "react-router";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { CustomerStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { AccountRoleWithAccountDetails } from "../../../../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { CustomerNewProductLink } from "../../../../../../../Wrap/Models/Models/Customer/CustomerNewProductLink";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { LoadingSkeletonType } from "../../../../../../Shared/LoadingSkeleton/Contents";
import { LoadingSkeleton } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { LoadingSkeletonWrapper } from "../../../../../../Shared/LoadingSkeleton/LoadingSkeletonWrapper";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { Action } from "../../../../../Actions/Action";
import { StaticUrls } from "../../../../../Resoures/StaticUrls";
import { UserStore } from "../../../../../Stroes/Variable";
import { Workflow } from "../../../../Dashboard/Components/Workflow/Workflow";
import { SelectAccountLightbox } from "../../../../SelectAccountLightbox";
import { OldNewTrustWizard } from "../../../AddClient/Resource/Contents";
import { CreateUserIcon } from "../../../ClientRecord/Components/CreateUserIcon";
import { RouteIcon } from "../../../ClientRecord/Components/RouteIcon";
import { SignpostIcon } from "../../../ClientRecord/Components/SignpostIcon";
import { PortfolioDashboardAction } from "../../Action/PortfolioDashboardAction";
import {
    PortfolioDashboardAccountRolesStore,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../Store/Variable";
import { IPortfolioDashboardComponentProps, PortfolioDashboardComponent } from "../Common/PortfolioDashboardComponent";
import { selectedHeadAccountsOnly } from "../Common/PortfolioDashboardHelper";
import { Urls } from "../../../../../Urls";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { AccountStatus } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { RoleStatus } from "../../../../../../../Wrap/Constants/Enums/RoleStatus";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { InvestorType } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";

interface IPortfolioDashboardActivityState {
    isAccountRoleLoading: boolean;
    isAccountLoading: boolean;
    headAccounts: string[];
    subAccounts: string[];
    showAccountLightbox?: boolean;
    links: CustomerNewProductLink[];
    errorMsg: string;
    roles: AccountRoleWithAccountDetails;
    userInfo: User;
}

interface IPortfolioDashboardActivityProps extends IPortfolioDashboardComponentProps {
    isProspect: boolean;
    customerType: CustomerType;
}

export class PortfolioDashboardActivity extends PortfolioDashboardComponent<
    IPortfolioDashboardActivityProps,
    IPortfolioDashboardActivityState
> {
    constructor(props: IPortfolioDashboardActivityProps) {
        super(props);
        this.subscribeToStore(PortfolioDashboardAccountRolesStore, () => this.onStoreChange());
        this.subscribeToStore(PortfolioDashboardStore, () => this.onStoreChange());
    }

    initState() {
        this.state = {
            isAccountRoleLoading: true,
            isAccountLoading: true,
            headAccounts: [],
            subAccounts: [],
            showAccountLightbox: false,
            links: [],
            errorMsg: null,
            roles: null,
            userInfo: UserStore.getUserInfo()
        };
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    private onStoreChange() {
        const roles = PortfolioDashboardAccountRolesStore.getData();
        this.setState({ roles: roles, isAccountRoleLoading: false });
        this.handleAccountRoles(roles, PortfolioDashboardMultiSelectionStore.getData());
    }

    private canCreateOrEditUser() {
        //conditions to hide create user :
        //1. hold ShareholderGT25 only
        //2. hold LetterOfAuthority only
        //3. hold both LetterOfAuthority and ShareholderGT25 only
        //4. hold no roles
        //5. organisation but not corporate trustee
        //TODO : some condition above may not valid need to check with Dan
        const { roles } = this.state;
        const _accountroles = roles?.AccountRoles || [];
        const shareholderGT25Len = _accountroles.filter((ele) => ele.AccountRoleType == RoleType.ShareholderGT25)
            .length;
        const letterOfAuthLen = _accountroles.filter((ele) => ele.AccountRoleType == RoleType.ShareholderGT25).length;
        const invalidLen = shareholderGT25Len + letterOfAuthLen;
        if (
            _accountroles.some(
                (ele) => ele.AccountRoleType == RoleType.Trustee && ele.AccountRoleStatus == RoleStatus.Active
            ) &&
            this.props.customerType != CustomerType.Individual
        ) {
            return true;
        }
        if (
            invalidLen == _accountroles.length ||
            (roles?.AccountRoles || []).filter(
                (role) =>
                    role.AccountStatus.toLowerCase() != "inprogress" && role.AccountRoleStatus != RoleStatus.Inactive
            ).length == 0 ||
            this.props.customerType != CustomerType.Individual
        ) {
            return false;
        } else {
            return true;
        }
    }

    getData(selectedSubAccountHierarchyIds: string[]) {
        this.handleAccountRoles(this.state.roles, selectedSubAccountHierarchyIds);
    }

    componentDidMount() {
        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: Urls.get()
                    .main.PortfolioDashboard({
                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                            HierarchyLevelName.Customer,
                            this.props.customerid
                        ),
                    })
                    .activity.getUrl(),
                pageTitle: `${document.title} - client - activity`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
        PortfolioDashboardAction.getAccountRoleWithAccountDetails(this.props.customerid);
    }

    handleAccountRoles(roles: AccountRoleWithAccountDetails, selectedSubAccounts: string[]) {
        if (!roles || roles?.AccountRoles?.length == 0) {
            this.setState({ isAccountLoading: false });
            return;
        }
        if (this.props.isProspect) {
            const headAccountRoles = roles.AccountRoles.filter(
                (f) => !roles.SubAccountInfos.some((x) => x.ClAccountId == f.ClAccountId)
            );
            const headAccounts = headAccountRoles.map((x) =>
                HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Account, x.AccountId)
            );
            const subAccounts = roles.SubAccountInfos.map((x) => x.HierarchyId);
            this.setState({ headAccounts: headAccounts, subAccounts: subAccounts, isAccountLoading: false });
        } else {
            const allAccounts = PortfolioDashboardStore.getData();
            const allAccountsIncludePending = PortfolioDashboardStore.getFullAccounts();
            let headAccounts = selectedHeadAccountsOnly(selectedSubAccounts, allAccounts);
            if (allAccountsIncludePending.length != allAccounts.length) {
                headAccounts = headAccounts.concat(
                    allAccountsIncludePending.filter((ele) => ele.AccountStatus == AccountStatus.InProgress)
                );
            }
            this.setState({
                subAccounts: selectedSubAccounts,
                headAccounts: headAccounts.map((x) => x.HierarchyId),
                isAccountLoading: false,
            });
        }
    }

    private noCard(): boolean {
        const userInfo = UserStore.getUserInfo();
        if (
            this.state.roles?.PersonalDetails?.CustomerStatus === CustomerStatus.Inactive ||
            this.props.hasReadWriteAccessToAdviser != true ||
            userInfo?.IsReadOnly == true
        ) {
            return true;
        }
        return false;
    }

    private async hasDpcSubAccount(account: ClientAccount) {
        const nprSubaccount = account?.SubAccounts?.find((item) => item.SubAccountType == SubAccountType.Npr);
        if (!nprSubaccount) return false;

        const pensionSubAccountSettings = await Action.getPensionSubAccountSettings(nprSubaccount.HierarchyId, true);
        return pensionSubAccountSettings?.HasDisqualifyingPensionCredit;
    }

    private renderCard() {
        const customerId = this.props.customerid;
        const { roles } = this.state;
        if (this.noCard()) {
            return null;
        }
        return (
            <>
                <div className="container size-900">
                    <div className="row text-center">
                        {this.props.isProspect &&
                            this.props.customerType != CustomerType.Trust &&
                            this.props.customerType != CustomerType.CorporateTrust &&
                            this.props.customerType != CustomerType.Company &&
                            checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) && (
                                <div className="col-4 col-equalise">
                                    <div className="panel-elevated">
                                        <div className="mb-32">
                                            <SignpostIcon cssWrapper="size-100" />
                                        </div>
                                        <Link
                                            className="btn primary"
                                            onClick={() => {
                                                this.addEvent({
                                                    event: "activitytab_interaction",
                                                    eventParameters: {
                                                        eventAction: "interactions",
                                                        eventCategory: eventCategoryForGTM.activityTab,
                                                        eventLabel: "start a quote",
                                                    },
                                                });
                                            }}
                                            to={StaticUrls.QuoteWrapperSelectionUrlCustomer(customerId.toString())}
                                        >
                                            Start a quote
                                        </Link>
                                    </div>
                                </div>
                            )}
                        <div className="col-4 col-equalise">
                            {checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) &&
                                this.props.customerType != CustomerType.Company && (
                                    <div className="panel-elevated">
                                        <div className="mb-32">
                                            <RouteIcon cssWrapper="size-100" />
                                        </div>
                                        {!this.props.isProspect && (
                                            <button
                                                className="btn primary"
                                                onClick={() => {
                                                    this.addEvent({
                                                        event: "activitytab_interaction",
                                                        eventParameters: {
                                                            eventAction: "interactions",
                                                            eventCategory: eventCategoryForGTM.activityTab,
                                                            eventLabel: "new product",
                                                        },
                                                    });
                                                    Action.getNewProductLink(
                                                        customerId,
                                                        async (links: CustomerNewProductLink[]) => {
                                                            if (links.length == 0) {
                                                                this.setState({
                                                                    errorMsg:
                                                                        "New product journey not available for this type of Account.",
                                                                    showAccountLightbox: true,
                                                                });
                                                            } else if (links.length == 1 && ![InvestorType.Joint, InvestorType.JointIndividual].includes(links[0].Account.InvestorType)) {
                                                                if (
                                                                    links[0].IsActive &&
                                                                    !(
                                                                        await this.hasDpcSubAccount(links[0].Account) &&
                                                                        this.state.userInfo?.IsAdviser
                                                                    )
                                                                ) {
                                                                    window.location.assign(links[0].Link);
                                                                } else {
                                                                    this.setState({
                                                                        errorMsg:
                                                                            "New product journey not available for this type of Account.",
                                                                        showAccountLightbox: true,
                                                                    });
                                                                }
                                                            } else {
                                                                this.setState({
                                                                    links: links,
                                                                    showAccountLightbox: true,
                                                                });
                                                            }
                                                        }
                                                    );
                                                }}
                                            >
                                                New product
                                            </button>
                                        )}
                                        {this.props.isProspect &&
                                            this.props.customerType == CustomerType.Individual &&
                                            checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) && (
                                                <button
                                                    className="btn primary"
                                                    disabled={PortfolioDashboardStore.hasInProgressAccounts()}
                                                    onClick={() => {
                                                        this.addEvent({
                                                            event: "activitytab_interaction",
                                                            eventParameters: {
                                                                eventAction: "interactions",
                                                                eventCategory: eventCategoryForGTM.activityTab,
                                                                eventLabel: "start new business",
                                                            },
                                                        });
                                                        window.location.assign(
                                                            `/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=${customerId}`
                                                        );
                                                    }}
                                                >
                                                    Start New Business
                                                </button>
                                            )}
                                        {this.props.isProspect &&
                                            (this.props.customerType == CustomerType.CorporateTrust ||
                                                this.props.customerType == CustomerType.Trust) &&
                                            checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) && (
                                                <button
                                                    className="btn primary"
                                                    disabled={PortfolioDashboardStore.hasInProgressAccounts()}
                                                    onClick={() => {
                                                        this.addEvent({
                                                            event: "activitytab_interaction",
                                                            eventParameters: {
                                                                eventAction: "interactions",
                                                                eventCategory: eventCategoryForGTM.activityTab,
                                                                eventLabel: "start new business",
                                                            },
                                                        });
                                                        window.location.href =
                                                            OldNewTrustWizard +
                                                            `?customerid=${this.props.customerid.toString()}`;
                                                    }}
                                                >
                                                    Start New Business
                                                </button>
                                            )}
                                    </div>
                                )}
                        </div>
                        {this.canCreateOrEditUser() &&
                            ((checkPermission(UserClaim.AdviserPortalDluEditUserCanView) && roles?.ActorUserId > 0) ||
                                ((roles?.ActorUserId == 0 || roles?.ActorUserId == undefined) &&
                                    checkPermission(UserClaim.AdviserPortalDluNewUserCanView))) && (
                                <div className="col-4 col-equalise">
                                    <div className="panel-elevated">
                                        <div className="mb-32">
                                            <CreateUserIcon cssWrapper="size-100" />
                                        </div>
                                        {this.state.roles?.ActorUserId > 0 ? (
                                            <button
                                                className="btn primary"
                                                onClick={() => {
                                                    this.addEvent({
                                                        event: "activitytab_interaction",
                                                        eventParameters: {
                                                            eventAction: "interactions",
                                                            eventCategory: eventCategoryForGTM.activityTab,
                                                            eventLabel: "edit user",
                                                        },
                                                    });
                                                    window.location.assign(
                                                        `/admin/users/edituser.aspx?searchuserid=${roles?.ActorUserId}&type=EDIT`
                                                    );
                                                }}
                                            >
                                                Edit User
                                            </button>
                                        ) : (
                                            <button
                                                className="btn primary"
                                                onClick={() => {
                                                    this.addEvent({
                                                        event: "activitytab_interaction",
                                                        eventParameters: {
                                                            eventAction: "interactions",
                                                            eventCategory: eventCategoryForGTM.activityTab,
                                                            eventLabel: "create user",
                                                        },
                                                    });
                                                    window.location.assign(
                                                        `/admin/users/newuser.aspx?customerid=${customerId}`
                                                    );
                                                }}
                                            >
                                                Create User
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </>
        );
    }

    private renderAccountsLightbox() {
        return (
            <>
                {this.state.showAccountLightbox && (
                    <Lightbox
                        show={this.state.showAccountLightbox}
                        title={this.state.errorMsg ? "" : "Please select an account"}
                        onClose={() => this.setState({ showAccountLightbox: false, errorMsg: null })}
                        type={LightboxType.Modal}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <SelectAccountLightbox
                            customerId={this.props.customerid}
                            links={this.state.links}
                            errorMsg={this.state.errorMsg}
                            displayNewBusiness={!PortfolioDashboardStore.hasInProgressAccounts()}
                        />
                    </Lightbox>
                )}
            </>
        );
    }

    render() {
        const { isAccountRoleLoading, isAccountLoading, headAccounts, subAccounts } = this.state;
        if (isAccountRoleLoading || isAccountLoading) {
            return <LoadingSkeleton type={LoadingSkeletonType.Table} />;
        }

        return (
            <LoadingSkeletonWrapper isLoading={isAccountRoleLoading || isAccountLoading} skeletonType={LoadingSkeletonType.Table}>
                <div className="mb-20" role="tabpanel" id="panel-5" tabIndex={0} aria-labelledby="tab-5">
                    <Workflow
                        selectedHeadAccounts={headAccounts}
                        selectedSubAccounts={subAccounts}
                        customerId={this.props.customerid}
                        isActivity={true}
                        notProspect={!this.props.isProspect}
                    />
                </div>

                {this.renderCard()}
                {this.renderAccountsLightbox()}
            </LoadingSkeletonWrapper>
        );
    }
}
